
import { Action as FuelEconomyStatsAction } from '../actions/fuelEconomyStats';
import { Action as FuelLogsAction } from '../actions/fuelLogs';

const defaultState = {
  statsMap: {},
  isFetching: false,
  error: undefined,
};

export default function fuelEconomyStatsReducer(state = defaultState, action) {
  switch (action?.type) {
    case FuelEconomyStatsAction.FuelEconomyStats.FetchFuelEconomyStatsPending:
      return {
        ...state,
        isFetching: true,
        error: undefined,
      };

    case FuelEconomyStatsAction.FuelEconomyStats.FetchFuelEconomyStatsCompleted:
    case FuelLogsAction.FuelLogEntry.AddFuelLogEntryCompleted:
    case FuelLogsAction.FuelLogEntry.UpdateFuelLogEntryCompleted:
      return {
        ...state,
        isFetching: false,
        statsMap: {
          ...state.statsMap,
          [action.meta.vehicleGuid]: action.payload.fuelEconomyStats,
        },
      };

    case FuelEconomyStatsAction.FuelEconomyStats.FetchFuelEconomyStatsFailed:
      return {
        ...state,
        isFetching: false,
        error: 'There was an error fetching fuel economy stats for your vehicle',
      };

    default: {
      return state;
    }
  }
}
